import { WorklistTab } from 'config/constants';
import { getSurfaceLabel } from '../Toolbar/WorklistToolbar';
import { WorklistSurface, WorklistSurfaceType } from '../types';

export const isProvidedCannedWorklist = ({
  currentSurface,
  comparatorSurface,
  customWorklistName,
}: {
  currentSurface: WorklistSurfaceType;
  comparatorSurface: WorklistSurfaceType;
  customWorklistName?: string | null;
}): boolean => {
  if (currentSurface == null) {
    return false;
  }

  // If the current surface is not custom worklist, then we can compare directly
  if (currentSurface !== WorklistSurface.CUSTOM_WORKLIST) {
    return currentSurface === comparatorSurface;
  }

  const labelToCompare = getSurfaceLabel(comparatorSurface as WorklistTab);

  if (customWorklistName == null || customWorklistName.trim() === '') {
    return false;
  }
  if (labelToCompare == null) {
    return false;
  }

  return customWorklistName.toLowerCase().trim() === labelToCompare.toLowerCase().trim();
};

// This works very similarly to above, but takes in an array of names instead
export const isAnyProvidedCannedWorklist = ({
  currentSurface,
  comparatorSurface,
  customWorklistNames = [],
}: {
  currentSurface: WorklistSurfaceType;
  comparatorSurface: WorklistSurfaceType;
  customWorklistNames?: (string | null)[];
}): boolean => {
  if (currentSurface == null) {
    return false;
  }

  if (currentSurface !== WorklistSurface.CUSTOM_WORKLIST) {
    return currentSurface === comparatorSurface;
  }

  if (customWorklistNames.length === 0) {
    return false;
  }

  const labelToCompare = getSurfaceLabel(comparatorSurface as WorklistTab);

  if (labelToCompare == null) {
    return false;
  }

  return customWorklistNames.some(
    (customWorklistName) =>
      customWorklistName &&
      customWorklistName.toLowerCase().trim() === labelToCompare.toLowerCase().trim()
  );
};
